import React from 'react';

import CustomSpinner from 'modules/ui/mobile/CustomSpinner.component';
import CustomListView from 'modules/listview/mobile/customList.component';
import { View } from 'react-native';
import { BodyText, Box } from 'modules/styled';
import { useRelatedUsers } from '../hooks';
import { renderRow, renderHeader } from '../related.common';

export const RelatedUsers = ({ navigation }: { navigation: any }): JSX.Element => {
  const { params } = navigation?.state || {};
  const { data, loading, refetch } = useRelatedUsers(params.id);
  if (loading) return <CustomSpinner />;

  return (
    <View style={{ flex: 1 }}>
      <CustomListView
        data={data?.relatedUsers || []}
        loaded={!loading}
        renderHeader={() => <Box sx={{ p: 2 }}>{renderHeader()}</Box>}
        renderRow={renderRow}
        load={() => ({})} // add reload ?
        onReload={refetch}
        type={'related users'}
        parent={'related users'}
        active
        view={0}
        scrollableTab
      >
        <BodyText sx={{ fontSize: 5, lineHeight: 5, textAlign: 'center' }}>
          No related accounts.
        </BodyText>
      </CustomListView>
    </View>
  );
};

export default RelatedUsers;
